import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const heroes = document.querySelectorAll("[data-wv-hero]");
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  heroes.forEach((hero) => {
    const flipItems = hero.querySelectorAll(".hero-flip-item");
    const imageReveals = hero.querySelectorAll(".hero-image-reveal img");

    if (prefersReducedMotion) {
      gsap.set(flipItems, {
        opacity: 1,
        rotationX: 0,
        yPercent: 0,
      });

      gsap.set(imageReveals, {
        clipPath: "none",
        opacity: 1,
        x: 0,
      });

      return;
    }

    const tl = gsap.timeline({
      defaults: {
        ease: "power3.out",
      },
    });

    gsap.set(flipItems, {
      opacity: 0,
      rotationX: -90,
      yPercent: -20,
      transformOrigin: "top center",
    });

    gsap.set(imageReveals, {
      clipPath: "inset(0 100% 0 0)",
      opacity: 1,
      x: 0,
    });

    tl.to(flipItems, {
      opacity: 1,
      rotationX: 0,
      yPercent: 0,
      duration: 0.9,
      stagger: 0.16,
      delay: 0.4,
    });

    tl.to(
      imageReveals,
      {
        clipPath: "inset(0 0% 0 0)",
        duration: 1.1,
        stagger: 0.18,
        ease: "power2.out",
      },
      "-=0.25"
    );
  });
});